import type { TagTone } from '../../ui/Tag/types';

// A first reminder is routine; the second starts to need attention and from the third on the
// customer is the one to chase first.
export const relanceRankTone = (rank: number): TagTone => {
    if (rank >= 3) return 'level1';
    if (rank === 2) return 'level2';
    return 'neutral';
};
